import { faRedo } from '@fortawesome/pro-regular-svg-icons/faRedo';
import _pt from 'prop-types';
import 'react';
import cn from 'classnames';
import { v4 } from 'uuid';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@ebsco-ui/button';
import { jsxs, jsx } from 'react/jsx-runtime';

var DefaultImage = function DefaultImage() {
  return /*#__PURE__*/jsxs("svg", {
    viewBox: "0 0 122 76",
    width: "122px",
    height: "76px",
    "data-auto": "eb-page-error-message__default-image",
    children: [/*#__PURE__*/jsx("path", {
      id: "case",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#002F56",
      d: "M116.6,36L116.6,36L116.6,36c-0.1-0.1-0.2-0.2-0.3-0.3 L92.8,5.3C90.2,1.9,86.3,0,82.1,0c-8,0-14.2,6.8-13.5,14.8l0,0.2H52.8l0-0.1l0-0.1c0-0.4,0.1-0.8,0.1-1.3c0-0.8-0.1-1.6-0.2-2.4 C51.6,4.9,46.1,0,39.4,0c-4.2,0-8.1,1.9-10.7,5.3l-4.6,5.9l-18.6,24c0,0,0,0,0,0c0,0,0,0,0,0l-0.5,0.7c0,0,0,0,0,0c0,0,0,0,0,0l0,0 h0C2,39.8,0.3,44.4,0,49.5c0,0.4,0,0.8,0,1.2C0,63,8.9,73.2,20.6,75.1c1.3,0.2,2.7,0.3,4.2,0.3c13.7,0,24.8-11.1,24.8-24.8 c0,0,0,0,0,0l0.8-8.4v0h20.7v0l0.8,8.4l0,0c0,13.7,11.1,24.8,24.8,24.8c13.7,0,24.8-11.1,24.8-24.8C121.4,45.2,119.6,40.1,116.6,36z "
    }), /*#__PURE__*/jsx("polygon", {
      id: "case-bar",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#002341",
      points: "50.8,37.3 70.5,37.3 68.6,14.9 52.8,14.9"
    }), /*#__PURE__*/jsxs("g", {
      id: "lensRight",
      transform: "translate(84.000000, 30.000000)",
      children: [/*#__PURE__*/jsx("path", {
        id: "glassRight",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#D8E3F5",
        d: "M33.9,20.7c0,11.8-9.5,21.3-21.3,21.3 S-8.7,32.5-8.7,20.7S0.9-0.6,12.6-0.6S33.9,8.9,33.9,20.7"
      }), /*#__PURE__*/jsx("polygon", {
        id: "reflectRightLg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "26.1,39.4 -5.7,7.6 -0.5,2.4 31.3,34.2"
      }), /*#__PURE__*/jsx("polygon", {
        id: "reflectRightSm",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "32.8,32.7 1,0.9 2.1,-0.2 33.9,31.6 "
      }), /*#__PURE__*/jsx("path", {
        id: "ringRight",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#A7AAAF",
        d: "M28.9,29.8c-0.2,0.4-0.5,0.9-0.8,1.3 c-1.4,2.1-3.2,3.8-5.2,5.2c-3,2-6.5,3.1-10.3,3.1C2.3,39.4-6,31-6,20.7c0-0.7,0-1.4,0.1-2c0.3-3,1.4-5.8,3-8.3 c1.4-2.1,3.1-3.8,5.2-5.2c0.6-0.4,1.3-0.8,1.9-1.1c0.5-0.3,1-0.5,1.5-0.7c0.5-0.2,1-0.4,1.6-0.5C9,2.3,10.8,2,12.6,2 c5.4,0,10.3,2.3,13.7,6c3.1,3.3,5,7.8,5,12.7c0,2.5-0.5,4.8-1.3,6.9c-0.2,0.5-0.4,1-0.7,1.5C29.2,29.4,29.1,29.6,28.9,29.8 M32.6,6 c-0.2-0.3-0.4-0.6-0.6-0.8c-4.5-5.6-11.5-9.2-19.3-9.2c-3.3,0-6.5,0.7-9.4,1.9c-9,3.7-15.4,12.6-15.4,22.9 c0,13.7,11.1,24.8,24.8,24.8c8.4,0,15.9-4.2,20.3-10.6c2.8-4,4.4-8.9,4.4-14.2C37.4,15.2,35.6,10.1,32.6,6"
      })]
    }), /*#__PURE__*/jsxs("g", {
      id: "lensLeft",
      transform: "translate(11.000000, 30.000000)",
      children: [/*#__PURE__*/jsx("path", {
        id: "glassLeft",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#D8E3F5",
        d: "M35.1,20.7c0,11.8-9.5,21.3-21.3,21.3 S-7.5,32.5-7.5,20.7S2-0.6,13.8-0.6S35.1,8.9,35.1,20.7"
      }), /*#__PURE__*/jsx("polygon", {
        id: "reflectLeftLg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "25.6,39.4 -6.3,7.6 -1.1,2.4 30.7,34.2 \t"
      }), /*#__PURE__*/jsx("polygon", {
        id: "reflectLeftSm",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "32.3,32.7 0.4,0.9 1.6,-0.2 33.4,31.6 \t"
      }), /*#__PURE__*/jsx("path", {
        id: "ringLeft",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#A7AAAF",
        d: "M29.8,30.3c-0.4,0.6-0.8,1.2-1.2,1.8 c-1.5,2-3.4,3.6-5.6,4.8c-2.7,1.6-5.9,2.5-9.3,2.5c-5,0-9.6-2-13-5.2c-1.1-1.1-2.1-2.3-3-3.7c-1.7-2.8-2.7-6.2-2.7-9.7 c0-3.4,0.9-6.5,2.5-9.3c0.7-1.2,1.6-2.4,2.5-3.4c0.7-0.8,1.5-1.5,2.3-2.1C3,5.5,3.6,5,4.2,4.7c0.5-0.3,1-0.5,1.5-0.8 C8.1,2.7,10.9,2,13.8,2c9.6,0,17.6,7.3,18.6,16.6c0.1,0.7,0.1,1.4,0.1,2c0,2.9-0.7,5.7-1.8,8.1C30.4,29.3,30.1,29.8,29.8,30.3 M13.8-4.1C6-4.1-1-0.5-5.5,5.2c0,0,0,0,0,0l-0.5,0.7c0,0,0,0,0,0c0,0,0,0,0,0h0C-9,9.8-10.7,14.4-11,19.5c0,0.4,0,0.8,0,1.2 C-11,33-2.1,43.2,9.6,45.1c1.3,0.2,2.7,0.3,4.1,0.3c13.7,0,24.8-11.1,24.8-24.8C38.6,7,27.5-4.1,13.8-4.1"
      })]
    })]
  });
};

var IMAGE_PLACEMENT = {
  blockStart: "block-start",
  blockEnd: "block-end"
};
var DEFAULT_TITLE_TAG = "h2";
var BASE_CLASS_NAME = "eb-page-error-message";

var PageErrorMessage = function PageErrorMessage(props) {
  var titleTag = props.titleTag,
      _props$buttonIcon = props.buttonIcon,
      buttonIcon = _props$buttonIcon === void 0 ? faRedo : _props$buttonIcon,
      _props$buttonText = props.buttonText,
      buttonText = _props$buttonText === void 0 ? "" : _props$buttonText,
      consumerBaseClassName = props.className,
      _props$image = props.image,
      image = _props$image === void 0 ? null : _props$image,
      _props$imagePlacement = props.imagePlacement,
      imagePlacement = _props$imagePlacement === void 0 ? IMAGE_PLACEMENT.blockStart : _props$imagePlacement,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? null : _props$onClick,
      _props$subTitle = props.subTitle,
      subTitle = _props$subTitle === void 0 ? "" : _props$subTitle,
      _props$text = props.text,
      text = _props$text === void 0 ? "" : _props$text,
      title = props.title; // We need unique IDs to support screen readers in rare case
  // of having multiple PageErrorMessages on the same page

  var uniquePart = v4();
  var titleId = "title-".concat(uniquePart);
  var subTitleId = "sub-title-".concat(uniquePart);
  var textId = "text-".concat(uniquePart);
  var TitleTag = titleTag || DEFAULT_TITLE_TAG;
  var getBEMBlocksWith = createBemBlockBuilder([BASE_CLASS_NAME, consumerBaseClassName]);

  var renderImage = function renderImage(position) {
    return /*#__PURE__*/jsx("div", {
      className: cn(getBEMBlocksWith("__image"), getBEMBlocksWith("__image--".concat(position))),
      "aria-hidden": "true",
      children: image || /*#__PURE__*/jsx(DefaultImage, {})
    });
  };

  return /*#__PURE__*/jsxs("div", {
    role: "alert",
    "aria-labelledby": "".concat(titleId, " ").concat(subTitleId),
    "aria-describedby": textId,
    className: getBEMBlocksWith(),
    children: [imagePlacement === IMAGE_PLACEMENT.blockStart && renderImage(imagePlacement), /*#__PURE__*/jsx(TitleTag, {
      id: titleId,
      className: getBEMBlocksWith("__title"),
      children: title
    }), subTitle && /*#__PURE__*/jsx("p", {
      id: subTitleId,
      className: getBEMBlocksWith("__sub-title"),
      children: subTitle
    }), text && /*#__PURE__*/jsx("p", {
      id: textId,
      className: getBEMBlocksWith("__text"),
      children: text
    }), buttonText && onClick && /*#__PURE__*/jsxs(Button, {
      className: getBEMBlocksWith("__button"),
      onClick: onClick,
      children: [buttonIcon && /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: buttonIcon,
        className: getBEMBlocksWith("__button-icon"),
        "aria-hidden": "true"
      }), buttonText]
    }), imagePlacement === IMAGE_PLACEMENT.blockEnd && renderImage(imagePlacement)]
  });
};

PageErrorMessage.propTypes = {
  buttonText: _pt.string,
  className: _pt.string,
  image: _pt.node,
  imagePlacement: _pt.oneOf(["block-start", "block-end"]),
  subTitle: _pt.string,
  title: _pt.string.isRequired,
  titleTag: _pt.any,
  text: _pt.string,
  onClick: _pt.func
};

export { IMAGE_PLACEMENT, PageErrorMessage as default };
//# sourceMappingURL=page-error-message-esm.js.map
